import React, { Component } from 'react';
import { arrayOf, bool, func, history, number, object, shape, string } from 'prop-types';
import classnames from 'classnames';
import CheckboxInput from 'ps-components/Input/CheckboxInput';
import Dropdown from 'ps-components/Dropdown/Dropdown';
import './SurveyJobMatchesSubHeader.scss';
import { SLIDEOUTS } from '../../../Slideout/Slideouts';

class SurveyJobMatchesSubHeader extends Component {
  static propTypes = {
    history: object,
    clearSelectedSurveyJobs: func,
    selectedJob: shape({
      code: string,
      codeKey: string,
      currency: string,
      description: string,
      descriptionDocument: shape({
        fileLocation: string,
        title: string
      }),
      employeeCount: number,
      id: string,
      jobMatches: arrayOf(
        shape({
          id: string,
          orgJob: shape({
            id: string
          }),
          surveyJob: shape({
            code: string,
            description: string,
            id: string,
            survey: shape({
              code: string,
              id: string,
              name: string
            }),
            title: string
          })
        })
      ),
      name: string
    }),
    selectedSurveyJobs: arrayOf(string),
    showSlideout: func,
    showSurveyJobDescription: bool,
    toggleJobDescriptionSetting: func
  };

  openModal = () => {
    const { history, selectedJob, selectedSurveyJobs } = this.props;
    history.push(`/market-analysis/jobs/${selectedJob.id}/delete-matches`, {
      component: 'DELETE_JOB_MATCHES',
      modal: true,
      modalProps: {
        className: 'job-matching__modal-delete',
        orgJob: selectedJob,
        selectedSurveyJobs: selectedSurveyJobs
      },
      modalType: 'DELETE_JOB_MATCHES'
    });
  };

  openSlideout = () => {
    const { showSlideout } = this.props;
    showSlideout(SLIDEOUTS.COPY_MATCHES_SLIDEOUT);
  };

  render() {
    const {
      clearSelectedSurveyJobs,
      selectedSurveyJobs,
      showSurveyJobDescription,
      toggleJobDescriptionSetting
    } = this.props;

    const subheaderClass = classnames({
      'matches__sub-header': true,
      action__bar: selectedSurveyJobs.length > 0
    });

    return (
      <div className={subheaderClass}>
        {selectedSurveyJobs.length === 0 ? (
          <React.Fragment>
            <div className="matches__sub-header-label pxl-text-default">Survey Job Matches</div>
            <div className="matches__sub-header-setting pxl-text-small">
              <div className="benchmark__input-label">Benchmark Year</div>
              <Dropdown
                className="pxl-btn pxl-btn-sm benchmark__input"
                disabled={false}
                dropdownItems={['2018', '2019', '2020']}
                dropdownClass="benchmark__input-dropdown-items"
                itemOnClick={() => {
                  console.log('changed benchmark year');
                }}
                text={'2018'}
              />
              <CheckboxInput
                checked={showSurveyJobDescription}
                className="matches__sub-header-checkbox "
                onClick={this.props.toggleJobDescriptionSetting}
              />
              Show Survey Job Description
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div className="panel pxl-text-small">
              <div className="selected__count">{`${selectedSurveyJobs.length} selected`}</div>
              <div className="action__item" onClick={this.openSlideout}>
                <i className="icon icon__green icon-docs" />
                Copy Matches
              </div>
              <div className="action__item" onClick={this.openModal}>
                <i className="icon icon__green icon-trash" />
                Delete Matches
              </div>
            </div>
            <div className="panel pxl-text-small">
              <div className="action__item" onClick={clearSelectedSurveyJobs}>
                <i className="icon icon__large icon-cancel" />
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default SurveyJobMatchesSubHeader;
